import { Card, Form } from "antd";

export const LocationListForm = ({ form, provinces = [] }) => {
    const selectedProvince = Form.useWatch("province", form);
    const selectedDistrict = Form.useWatch("district", form);

    const provinceObj = provinces.find(
        (p) => p.key === selectedProvince
    );

    const districts =
        provinceObj?.districts ??
        provinceObj?.districtList ??
        provinceObj?.districtsDto ??
        [];

    return (
        <>
            <Form.Item name="province" rules={[{ required: true }]} hidden>
                <input />
            </Form.Item>

            <Form.Item name="district" rules={[{ required: true }]} hidden>
                <input />
            </Form.Item>

            {/* Province */}
            <Card type="inner" className="event-card-inner" title="Province" data-testid="card-province">
                <div
                    className="tile-grid capture-attendee-columns"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        rowGap: 14,
                        columnGap:12
                    }}
                    data-testid="province-grid"
                >
                    {provinces.map((province) => (
                        <div
                            key={province.key}
                            data-testid={`province-${province.key}`}
                            className={`tile ${selectedProvince === province.key ? "tile--active" : ""
                                }`}
                            onClick={() => {
                                form.setFieldsValue({
                                    province: province.key,
                                    district: undefined,
                                });
                            }}
                        >
                            {province.value}
                        </div>
                    ))}
                </div>
            </Card>


            {/* District */}
            <Card type="inner" className="event-card-inner" title="District" data-testid="card-district">
                {!selectedProvince ? (
                    <div style={{ color: "#888", fontSize: 13 }}>
                        Please select a Province
                    </div>
                ) : (
                    <div
                        className="tile-grid capture-attendee-columns"
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            rowGap: 14,
                            columnGap:12
                        }}
                        data-testid="district-grid"
                    >
                        {districts.map((district) => (
                            <div
                                key={district.key}
                                data-testid={`district-${district.key}`}
                                className={`tile ${selectedDistrict === district.key ? "tile--active" : ""
                                    }`}
                                onClick={() =>
                                    form.setFieldsValue({
                                        district: district.key,
                                    })
                                }
                            >
                                {district.value}
                            </div>
                        ))}
                    </div>
                )}
            </Card>
        </>
    );
};
